import { markAsReportedByApplication } from "../../helpers/newrelicErrorHandler";

export const sendError = (
    error: unknown,
    data?: Record<string, string>
): void => {
    if (process.env.NEXT_PUBLIC_DEPLOY_ENV) {
        let customAttributes = {
            "service.version":
                process.env.NEXT_PUBLIC_BUILD_NUMBER ?? "unknown",

            ...data,
        };
        if (error) {
            customAttributes = Object.assign({}, customAttributes, data, {
                // @ts-expect-error - error is not always an instance of Error
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                "custom.stack": error?.stack ?? "",
                // @ts-expect-error - error is not always an instance of Error
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                "custom.name": error?.name,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                "custom.message":
                    // @ts-expect-error - error is not always an instance of Error

                    typeof error?.message === "string"
                        ? // @ts-expect-error - error is not always an instance of Error

                          error.message
                        : "unknown",
                // @ts-expect-error - error is not always an instance of Error

                "custom.cause": JSON.stringify(error?.cause ?? ""),
            });
        }

        //It must be lib-dom window due to build issues. Do not use getWindow() here.
        if (typeof window === "undefined") {
            void import(/* webpackIgnore: true */ "newrelic").then(
                ({ default: newrelic }) => {
                    // eslint-disable-next-line no-console
                    console.log("[APM Error]", error);
                    newrelic.noticeError(error as Error, customAttributes);
                }
            );
        } else if (window.newrelic) {
            // Keeps this error out of the browser error handler filter, see
            // helpers/newrelicErrorHandler.ts
            markAsReportedByApplication(error);
            window.newrelic.noticeError(
                error as Error,
                customAttributes as never
            );
        }
    }
};
